import { Component, AfterViewInit, OnDestroy, ChangeDetectionStrategy, Input, ContentChild, TemplateRef } from '@angular/core';
import { Observable, combineLatest, BehaviorSubject, Subject, pipe, skip, of } from 'rxjs';
import { map, tap, switchMap, skipWhile, filter, startWith, shareReplay, takeUntil, distinctUntilChanged, take } from 'rxjs/operators';
import { sortOptions, PageName, SortBy, Pager, ParamsType, Taxonomies, DataSource } from '@app/constants';
import { DefaultIndexDoc } from '@app/graphql';
import { DataService, FetchService, ScrollService } from '@app/data';
import { RxState } from '@rx-angular/state';

interface DataStore {
  pager$: Pager,
  articles$: Observable<DefaultIndexDoc[]>,
  count$: Observable<string>,
  status$: Observable<string>,
  pageParams$: Observable<ParamsType>,
  dataSource: DataSource,
  fullText$: Observable<string>,
  setLastScrollPosition: Function
}

@Component({
  selector: 'app-data',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './data.component.html',
  styleUrls: ['./data.component.less'],
  providers:[RxState]
})
export class DataComponent implements OnDestroy {

  @ContentChild('optionTemplate') optionTemplateRef!: TemplateRef<any>;

  @Input() displayPage?: boolean;
  @Input() set dataSource(dataSource: DataSource) {
    console.log('**** DataComponent @Input() set dataSource dataSource ', dataSource);
    this.init$.next(dataSource);
  }

  // EVENTS
  init$ = new Subject<DataSource>();

  // HANDLERS
  initHandler$: Observable<any> = this.init$.pipe(
    filter((dataSource) => dataSource.storeName !== ''),
    take(2),
    switchMap((dataSource) => {
      console.log('**** DataComponent initHandler$ dataSource ', dataSource);
      this.state.set({dataSource});
      const _store = this.fetch.getStore(dataSource);
      this.state.connect('articles$', _store.articles$);
      this.state.connect('count$', _store.count$);
      this.state.connect('status$', _store.status$);
      this.state.connect('pageParams$', _store.pageParams$);
      this.setLastScrollPosition = _store.setLastScrollPosition;
      return _store.pager$;
      return of();
    })
  );
  
  public pager$ = this.state.select('pager$');
  public articles$ = this.state.select('articles$');
  public count$ = this.state.select('count$');
  public status$ = this.state.select('status$');
  public pageParams$ = this.state.select('pageParams$');

  private setLastScrollPosition: boolean | Function = false;
  public scrollInToView$: Subject<void> = new Subject();
  
  public show$ = this.pager$.pipe(
    map((res: Pager) => !(res.total === 0 && JSON.stringify(res.queryParams) === '{}'))
  );

  private unsubscribe$: Subject<void> = new Subject();


  constructor(
    private data: DataService,
    private fetch: FetchService,
    private scroll: ScrollService,
    private state: RxState<DataStore>
  ) {

    this.state.connect('pager$', this.initHandler$);


    this.scrollInToView$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
      //console.log('**** DataComponent scrollInToView$ res ', res);

      this.data.setScrollIntoView(this.state.get('dataSource', 'storeName'));
    });
  }

  ngOnDestroy(): void {
    //console.log('DataComponent ngOnDestroy');
    //this._store.setLastScrollPosition(this.scroll.getScrollPosition()[1]);

    if (this.setLastScrollPosition instanceof Function) {
      this.setLastScrollPosition(this.scroll.getScrollPosition()[1]);
    }

    this.unsubscribe$.next();
    this.unsubscribe$.complete();    
  }
}
